/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const LeadCalendarEventType = {
    ExpectedStartOfCare: 'expected_start_of_care',
    ActualStartOfCare: 'actual_start_of_care',
    ExpectedEndOfCare: 'expected_end_of_care',
    ActualEndOfCare: 'actual_end_of_care',
} as const;
export type LeadCalendarEventType = typeof LeadCalendarEventType[keyof typeof LeadCalendarEventType];


export function instanceOfLeadCalendarEventType(value: any): boolean {
    for (const key in LeadCalendarEventType) {
        if (Object.prototype.hasOwnProperty.call(LeadCalendarEventType, key)) {
            if (LeadCalendarEventType[key as keyof typeof LeadCalendarEventType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function LeadCalendarEventTypeFromJSON(json: any): LeadCalendarEventType {
    return LeadCalendarEventTypeFromJSONTyped(json, false);
}

export function LeadCalendarEventTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadCalendarEventType {
    return json as LeadCalendarEventType;
}

export function LeadCalendarEventTypeToJSON(value?: LeadCalendarEventType | null): any {
    return value as any;
}

export function LeadCalendarEventTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): LeadCalendarEventType {
    return value as LeadCalendarEventType;
}

